<template>
  <v-app :style="'background-color:'+inlineStyles.colors.main">
    <v-layout align-center justify-center column>
      <h1>Page Not Found</h1>
      <v-btn
        @click="goToMain()"
        :color="inlineStyles.colors.secondary"
        outlined
      >
        Go To Home
      </v-btn>
    </v-layout>
  </v-app>
</template>

<script scoped>
export default {
  name: "pageNotFound",
  props: {
		inlineStyles: {
			type: Object,
			require: true,
		},
	},
  methods: {
    goToMain() {
      this.$router.push({ name: "Home"})
    }
  }
}
</script>

<style>

</style>